import { CannedResponse } from '../types/cannedResponse';

export type CannedResponseLang = 'en' | 'ar';

export const CANNED_LANG_STORAGE_KEY = 'supportCannedInsertLang';

export function getCannedResponseBody(response: CannedResponse, lang: CannedResponseLang): string {
  if (lang === 'ar' && response.contentAr?.trim()) {
    return response.contentAr.trim();
  }
  return response.content;
}

export function getCannedResponseTitle(response: CannedResponse, lang: CannedResponseLang): string {
  if (lang === 'ar' && response.titleAr?.trim()) {
    return response.titleAr.trim();
  }
  return response.title;
}

export function getStoredCannedLang(): CannedResponseLang {
  try {
    const v = localStorage.getItem(CANNED_LANG_STORAGE_KEY);
    if (v === 'ar' || v === 'en') return v;
  } catch {
    /* ignore */
  }
  return 'en';
}

export function setStoredCannedLang(lang: CannedResponseLang): void {
  try {
    localStorage.setItem(CANNED_LANG_STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
}
